export const selfExclusionsCodes = new Set([
  'CROSS-PERM',
  'CROSS-TEMP',
  'LOCAL-PERM',
  'LOCAL-TEMP',
]);

export type ProductCategory = {
  categoryCode: string;
  productList: {
    productCode: string;
    description: string;
  }[];
};

export const productCategories: ProductCategory[] = [
  {
    categoryCode: 'Scommesse',
    productList: [
      { productCode: 'SS', description: 'Scommesse Sportive' },
      { productCode: 'SI', description: 'Scommesse Ippiche' },
      { productCode: 'TO', description: 'Totocalcio' },
      { productCode: 'VR', description: 'Virtual Race' },
    ],
  },
  {
    categoryCode: 'Casino e Poker',
    productList: [],
  },
];

export const games: Record<string, string> = productCategories
  .flatMap((category) => category.productList)
  .reduce<Record<string, string>>((acc, product) => {
    if (product.productCode === 'ALL') return acc;

    acc[product.productCode] = product.description;
    return acc;
  }, {});

export const gamesNumber = Object.keys(games).length;

export const activeExclusionsEndpoint =
  'responsible-gaming/v1/self-exclusion/exclusions/products';

export const postSelfExclusionEndpoint =
  'responsible-gaming/v1/self-exclusion/exclusions/products';

export const getCategoriesEndpoint =
  'responsible-gaming/v1/self-exclusion/categories';
